/**
 * Mengenstaffel auf der Produktseite (blocks/bundle-ladder.liquid).
 *
 * Verbindet die Staffel-Auswahl mit dem vorhandenen Mengenwaehler in
 * blocks/buy-buttons.liquid. Der Rabatt selbst passiert serverseitig ueber
 * drei automatische Rabatte im Admin - hier wird nur die Menge gesetzt.
 *
 * WICHTIG - Reihenfolge im DOM: die Staffel steht VOR dem Mengenwaehler.
 * Beim Skriptstart existiert das Feld also noch nicht. Ein direkter
 * addEventListener auf das Feld greift ins Leere (genau dieser Fehler ist
 * am 11.09. im Preview aufgefallen: Klick auf eine Stufe wirkte, das
 * Zurueckwandern der Markierung nicht). Beide Richtungen laufen deshalb
 * ueber Delegation am Abschnitt.
 */
(function () {
  function init(root) {
    if (root.dataset.bundleLadderReady === 'true') return;
    root.dataset.bundleLadderReady = 'true';

    var scope = root.closest('.shopify-section, [id^="shopify-section"]') || document;

    /* Die Sticky-Leiste rendert einen zweiten Mengenwaehler. Immer den im
       Seiteninhalt nehmen, sonst schreibt der Klick ins falsche Feld. */
    function quantityField() {
      var all = Array.prototype.slice.call(scope.querySelectorAll('input[name="quantity"]'));
      for (var i = 0; i < all.length; i++) {
        if (!all[i].closest('sticky-add-to-cart')) return all[i];
      }
      return all[0] || null;
    }

    /* Hinrichtung: Stufe geklickt -> Menge setzen. */
    root.addEventListener('change', function (event) {
      var radio = event.target;
      if (!radio || radio.type !== 'radio') return;

      var field = quantityField();
      if (!field) return;

      field.value = radio.value;
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    });

    /* Rueckrichtung: Menge ueber +/- geaendert -> Markierung wandert mit.
       Ohne das zeigt die Staffel eine Menge an, die nicht im Warenkorb landet. */
    function syncFromField(event) {
      var field = event.target;
      if (!field || field.name !== 'quantity') return;
      if (field.closest('sticky-add-to-cart')) return;

      var value = String(parseInt(field.value, 10));
      var radios = root.querySelectorAll('.bundle-ladder__radio');
      for (var i = 0; i < radios.length; i++) {
        radios[i].checked = radios[i].value === value;
      }
    }

    scope.addEventListener('change', syncFromField);
    scope.addEventListener('input', syncFromField);
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-bundle-ladder]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme-Editor rendert Abschnitte neu, ohne dass die Seite laedt. */
  document.addEventListener('shopify:section:load', boot);
})();
